import {map, sortBy} from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import Loader from '../../../../../components/Loader';
import FilterSelect from '../../../../../components/Filters/Select';
import {
  getUberEatsGame,
  getUberEatsUsersSecondaryWinners,
} from '../../../../../actions/entities/uberEats';
import './index.css';

class UberEatsBackupWinnersWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      filters: {
        days: [],
        gameWeek: [],
        matches: [],
        matchId: null,
        confrontations: [],
        selectedDay: null,
      },
      isFetching: false,
    };
  }

  fetchStats() {
    const {dispatch} = this.props;
    dispatch(
      getUberEatsUsersSecondaryWinners({
        gameWeekName: this.state.filters.selectedDay,
        matchId: this.state.filters.matchId,
      }),
      null,
      this.onError,
    );
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getUberEatsGame(), null, this.onError);
  }

  componentDidUpdate(prevProps, prevState) {
    const {filters} = this.state;
    const {game, secondaryWinners} = this.props;

    const days = sortBy(game?.data?.gameWeeks, week => {
      const day = parseInt(week?.name?.match(/\d+/)[0], 10);
      return day;
    })?.map(item => {
      return item.name;
    });

    const selectedDay = this.state?.filters?.selectedDay || days?.[0];

    const gameWeek =
      game?.data?.gameWeeks?.find(i => i.name === selectedDay) || [];

    const matches = gameWeek?.matches?.reduce((acc, curr) => {
      let obj = {
        gameWeekName: curr.id,
        home: curr.home,
        away: curr.away,
        confrontation: curr.home.shortName + ' - ' + curr.away.shortName,
      };
      acc.push(obj);
      return acc;
    }, []);

    const confrontations = matches?.map(match => {
      return {value: match.gameWeekName, text: match.confrontation};
    });

    const onDayChange =
      prevState.filters &&
      filters.selectedDay !== prevState.filters.selectedDay;

    const onConfrontationChange =
      prevState.filters && filters.matchId !== prevState.filters.matchId;

    if (onDayChange) {
      this.setState({
        filters: {
          ...this.state.filters,
          gameWeek,
          matches,
          confrontations,
        },
      });
    }

    if (onConfrontationChange || onDayChange) {
      this.setState({data: []});
    }

    if (prevProps.secondaryWinners !== this.props.secondaryWinners) {
      this.setState({
        data: secondaryWinners?.data,
      });
    }

    if (prevProps.game !== this.props.game) {
      this.setState({
        filters: {
          gameWeek,
          days,
          matches,
          confrontations,
          selectedDay,
        },
      });
    }
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  renderBody() {
    const {filters, data} = this.state;
    const table = data;

    if (!table) return false;

    const gameWeek = filters?.gameWeek;
    const match = gameWeek?.matches?.find(i => i.id === filters.matchId);

    return (
      <div className="box-body">
        <table className="table text-center table-striped">
          <thead>
            <tr>
              <th>ID user</th>
              <th>Pseudo</th>
              <th>Email</th>
              <th>N° tel</th>
              <th>Match joué</th>
              <th>Type de gain</th>
            </tr>
          </thead>
          <tbody>
            {map(table, (item, index) => {
              return (
                <tr key={index}>
                  <td>{item.userId}</td>
                  <td>{item.username}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td>
                    {match?.home?.shortName} - {match?.away?.shortName}
                  </td>
                  <td>{item.prize}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderFilters() {
    return (
      <div className="box-footer filters">
        <div className="col-sm-6 col-md-3 text-center">
          <label>{'Journée : '}</label>
          <select
            id="filter"
            className="form-control"
            value={this.state.filters.selectedDay}
            onChange={e => this.updateFilters({selectedDay: e.target.value})}>
            {this.state?.filters?.days?.map((day, key) => (
              <option key={key} value={day}>
                {day}
              </option>
            ))}
          </select>
        </div>
        <div className="col-sm-6 col-md-6">
          <FilterSelect
            onChange={matchId => this.updateFilters({matchId: matchId[0]})}
            options={this.state?.filters?.confrontations}
            initialValue={this.state?.filters?.confrontations?.[0]}
            selectProps={{multiple: true}}
          />
        </div>
        <button
          className="ml-2 inline btn btn-default"
          onClick={() => this.fetchStats()}>
          <i className="fa fa-refresh" />
        </button>
      </div>
    );
  }

  render() {
    const {isFetching} = this.props;

    return (
      <div id="ue-stats-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-gift" /> Back-up winners
              </h3>
            </div>
            {this.renderFilters()}
            <div className="box-body">{this.renderBody()}</div>
            {isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    game: state.app.uberEats.game,
    secondaryWinners: state.app.uberEats.secondaryWinners,
  }),
  dispatch => ({dispatch}),
)(UberEatsBackupWinnersWidget);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Stats/Widgets/BackupWinners/index.js